package ui.campaign.detailv2.editor.wrapper

import api.CampaignState
import common.frontend.api.Io
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__offsets_err_all_off
import tk.mallumo.utils.noDiacriticsLower
import tools.EFieldList
import tools.EFieldRegularBoolean
import tools.await

class CampaignWrapperEOffsets(
    val data: Io.Campaign,
) : ImplCampaignWrapperE {


    override val err: Boolean
        get() = adapter.state.all { it.excluded.state } && adapter.state.isNotEmpty()

    override suspend fun extractErr(): String? {
        return if (!err) null
        else Res.string.layer_top_detail_editor__offsets_err_all_off.await()
    }

    val adapter = AdapterCampaigns(data)

    private companion object {
        val Io.Campaign.OtherCampaignGroup.sort
            get() = when (CampaignState[state]) {
                CampaignState.ACTIVE -> 0
                CampaignState.PUBLISHED -> 1
                CampaignState.PAUSED -> 2
                CampaignState.DRAFT -> 3
                CampaignState.STOPPED -> 4
                CampaignState.FINISHED -> 5
                CampaignState.DELETED -> 6
            }
    }

    class AdapterCampaigns(
        data: Io.Campaign,
    ) : EFieldList<Io.Campaign.OtherCampaignGroup, AdapterCampaigns.Item>(
        items = data.otherCampaignGroups
            .asSequence()
            .filterNot { CampaignState.DELETED match it.state }
            .filterNot { CampaignState.STOPPED match it.state }
            .sortedWith(compareBy({ it.sort }, { it.name.noDiacriticsLower }))
            .toMutableList(),
        onBindEntry = {
            Item(it)
        }
    ) {

        class Item(
            override val data: Io.Campaign.OtherCampaignGroup,
            override val key: String = data.id.toString(),
        ) : Entry<Io.Campaign.OtherCampaignGroup> {
            val state = CampaignState[data.state]
            val excluded = EFieldRegularBoolean(data::exclude)
        }
    }
}